import _extends from '@babel/runtime/helpers/extends';

var linkAttributesNative = {
  color: 'secondary',

  /**
   * Margin as defined in CSS margin property
   */
  margin: '4px 3px 12px 12px',
  defaultSize: 'l'
};
var linkThemeNative = _extends({}, linkAttributesNative, {
  variants: {
    condensed: {
      defaultSize: 'm'
    }
  }
});
var linkThemeWeb = {
  color: 'secondary',
  underlineThickness: {
    "default": 'auto',
    hover: '2px'
  }
};

export { linkAttributesNative, linkThemeNative, linkThemeWeb };
